import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import { getResourceTypeText, getActionText } from './utils';

export default [
  {
    gridXs: 6,
    stateKey: 'resource',
    label: 'LOGS_PAGE.RESOURCE_TYPE_KEY',
    isSelect: true,
    options: [
      { value: 'all' },
      {
        value: 'operator',
      },
      {
        value: 'company',
      },
      {
        value: 'partner',
      },
      {
        value: 'environment',
      },
      {
        value: 'client',
      },
      {
        value: 'user',
      },
      {
        value: 'model',
      },
      {
        value: 'environment_application',
      },
      {
        value: 'client_application',
      },
      {
        value: 'user_session',
      },
      {
        value: 'partner_user_theme_config',
      },
      {
        value: 'operator_role',
      },
      {
        value: 'operator_role_objects',
      },
      {
        value: 'operator_role_permission',
      },
    ].map(item => ({
      ...item,
      label: item.value === 'all' ? 'ALL_KEY' : getResourceTypeText(item.value),
    })),
  },
  {
    gridXs: 6,
    stateKey: 'action',
    label: 'ACTION_KEY',
    isSelect: true,
    options: [
      { value: 'all' },
      {
        value: 'create_resource',
      },
      {
        value: 'update_resource',
      },
      {
        value: 'delete_resource',
      },
      {
        value: 'publish_resource',
      },
      {
        value: 'migrate_resource',
      },
    ].map(item => ({
      ...item,
      label: item.value === 'all' ? 'ALL_KEY' : getActionText(item.value),
    })),
  },
] as GenericFormItem[];
